import React, { Component } from 'react';

import { trans } from '@spotahome/soyuz/client';

import SectionHeading from './SectionHeading';
import CityList from './CityList';
import HomeSectionSubtitle from './HomeSectionSubtitle';

// styles
import './CitiesShowcase.scss';

class CitiesShowcase extends Component {
  static propTypes = {
    cityList: CityList.propTypes.cities.isRequired
  };

  state = {
    isCollapsed: true
  };

  handleOnClickCollapsed = event => {
    event.preventDefault();
    this.setState({
      isCollapsed: false
    });
  };

  render() {
    return (
      <div className="cities-showcase">
        <SectionHeading text={trans('landingpage.label.cities')} />

        <HomeSectionSubtitle>
          {trans('landingpage.label.cities_long')}
        </HomeSectionSubtitle>

        <CityList
          cities={this.props.cityList}
          isCollapsed={this.state.isCollapsed}
        />

        {this.state.isCollapsed && (
          <p className="cities-showcase__actions">
            <a
              className="cities-showcase__action"
              href="#"
              onClick={this.handleOnClickCollapsed}
            >
              {trans('landingpage.citylist.label.view_all_cities')}
            </a>
          </p>
        )}
      </div>
    );
  }
}

export default CitiesShowcase;
